import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link, withRouter } from 'react-router-dom';
import { compose, lifecycle, mapProps } from 'recompose';

import Routes from './Routes';
import * as styles from './styles.css';
import withStaffingCompanyGroup from '../containers/withStaffingCompanyGroup';

function Header({ logo, name, isHome }) {
  return (
    <div className="navbar navbar-static-top">
      <div className="container-fluid">
        <div className={classNames(styles.navHeader, 'navbar-header')}>
          {!isHome && (
            <Link to={Routes.home()} className={styles.backBtn}>
              <i className="fa fa-angle-left" />
            </Link>
          )}
          <Link to={Routes.home()}>
            <img
              src={logo}
              alt={name}
              className={classNames('navbar-brand img-responsive', styles.logo)}
            />
          </Link>
        </div>
      </div>
    </div>
  );
}

Header.propTypes = {
  logo: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  isHome: PropTypes.bool.isRequired,
};

export default compose(
  withStaffingCompanyGroup,
  withRouter,
  lifecycle({
    componentWillMount() {
      this.props.history.listen((location) => {
        this.setState({ location });
      });
    },
  }),
  mapProps(({ staffingCompanyGroup, location }) => ({
    logo: staffingCompanyGroup ? staffingCompanyGroup.get('logo') : undefined,
    name: staffingCompanyGroup ? staffingCompanyGroup.get('name') : undefined,
    isHome: location.pathname === '/' || location.pathname === '/login',
  })),
)(Header);
